module.exports = __webpack_public_path__ + "img/placeholder-illustration.931bde0f.svg";